import { TYPE_LABEL, PRICE_LABEL, TYPE_COLOR } from './config.js'
import { quartierOf, isSaved, toggleSaved } from './data.js'

let handlers = {}

export function initList(h) { handlers = h }

export function renderList(places) {
  const grid = document.getElementById('cards')
  const empty = document.getElementById('empty')
  grid.innerHTML = ''

  if (!places.length) {
    empty.hidden = false
    empty.innerHTML = `<span class="serif">Nothing here yet</span>
      <p>No places match these filters. Try clearing them or widening your search.</p>`
    return
  }
  empty.hidden = true

  const frag = document.createDocumentFragment()
  for (const p of places) frag.appendChild(p.locked ? lockedCard(p) : card(p))
  grid.appendChild(frag)
}

function card(p) {
  const el = document.createElement('article')
  el.className = 'card'
  el.dataset.id = p.id
  const coverSrc = (p.photos && p.photos[0]) || p.image
  const cover = coverSrc
    ? `<img src="${coverSrc}" alt="${esc(p.name)}" loading="lazy"
         onerror="this.replaceWith(Object.assign(document.createElement('div'),{className:'mono',style:'background:${TYPE_COLOR[p.type]}',textContent:'${esc(p.name[0] || '·')}'}))" />`
    : `<div class="mono" style="background:${TYPE_COLOR[p.type]}">${esc(p.name[0] || '·')}</div>`
  const meta = [quartierOf(p), p.price ? PRICE_LABEL[p.price] : '', TYPE_LABEL[p.type]?.replace(/s$/, '')]
    .filter(Boolean)
  const badges = []
  if (p.free) badges.push('<span class="badge-top10">★ Top 10</span>')
  if (p.michelin) badges.push(`<span class="michelin" title="${p.michelin} Michelin star${p.michelin > 1 ? 's' : ''}">${'★'.repeat(p.michelin)}</span>`)
  const badgeStack = badges.length ? `<div class="badges">${badges.join('')}</div>` : ''
  el.innerHTML = `
    <div class="photo">
      ${cover}
      ${badgeStack}
      <span class="cat">${esc(p.cuisine || TYPE_LABEL[p.type]?.replace(/s$/, '') || p.type)}</span>
      <button class="heart ${isSaved(p.id) ? 'saved' : ''}" aria-label="Save">${heartSvg}</button>
    </div>
    <div class="body">
      <h3 class="serif">${esc(p.name)}</h3>
      <div class="meta">${meta.map((m, i) => (i ? '<span class="dot"></span>' : '') + esc(m)).join('')}</div>
      <p>${esc(trim(p.blurb, 110))}</p>
    </div>`

  el.onmouseenter = () => handlers.onHover?.(p.id)
  el.onmouseleave = () => handlers.onLeave?.(p.id)
  el.onclick = () => handlers.onOpen?.(p.id)
  el.querySelector('.heart').onclick = (e) => {
    e.stopPropagation()
    const saved = toggleSaved(p.id)
    e.currentTarget.classList.toggle('saved', saved)
    handlers.onSaveChange?.()
  }
  return el
}

function lockedCard(p) {
  const el = document.createElement('article')
  el.className = 'card locked'
  el.dataset.id = p.id
  const typeLabel = TYPE_LABEL[p.type]?.replace(/s$/, '') || 'Place'
  const cover = p.blur
    ? `<img class="blur" src="${p.blur}" alt="" loading="lazy" />`
    : `<div class="lockmono" style="background:${TYPE_COLOR[p.type]}"></div>`
  const michelin = p.michelin
    ? `<span class="michelin">${'★'.repeat(p.michelin)}</span>` : ''
  const meta = [quartierOf(p), p.price ? PRICE_LABEL[p.price] : '', typeLabel].filter(Boolean)
  el.innerHTML = `
    <div class="photo">
      ${cover}
      <div class="lockveil"><span class="lockbadge">🔒</span></div>
      ${michelin}
      <span class="cat">${esc(p.cuisine || typeLabel)}</span>
    </div>
    <div class="body">
      <h3 class="serif">A locked spot</h3>
      <div class="meta">${meta.map((m, i) => (i ? '<span class="dot"></span>' : '') + esc(m)).join('')}</div>
      ${p.teaser ? `<p class="teaser">${esc(p.teaser)}</p>` : ''}
      <div class="lockline">Unlock to reveal the name, photos &amp; my full review.</div>
    </div>`
  el.onmouseenter = () => handlers.onHover?.(p.id)
  el.onmouseleave = () => handlers.onLeave?.(p.id)
  el.onclick = () => handlers.onLockedOpen?.(p.id)
  return el
}

export function highlightCard(id, on) {
  const c = document.querySelector(`.card[data-id="${CSS.escape(id)}"]`)
  if (!c) return
  c.classList.toggle('hl', on)
  if (on) c.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
}

const heartSvg = `<svg viewBox="0 0 24 24"><path stroke-linejoin="round" d="M12 20.6l-1.6-1.46C4.95 14.2 2 11.55 2 8.5 2 5.96 3.96 4 6.5 4c1.4 0 2.79.66 3.7 1.71L12 7.3l1.8-1.59C14.71 4.66 16.1 4 17.5 4 20.04 4 22 5.96 22 8.5c0 3.05-2.95 5.7-8.4 10.65L12 20.6Z"/></svg>`

function esc(s = '') {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
}
function trim(s = '', n) { return s.length > n ? s.slice(0, n).replace(/\s+\S*$/, '') + '…' : s }
